import { FC } from 'react';
import { GraduationCap, PiggyBank, Users, TrendingUp } from 'lucide-react';

const whyChooseUs = [
  {
    icon: GraduationCap,
    title: "Educación Transformadora",
    description: "Preparamos a la próxima generación con habilidades que la escuela tradicional no enseña"
  },
  {
    icon: PiggyBank,
    title: "Hábitos Financieros Saludables",
    description: "Desarrollamos una base sólida para la gestión del dinero y la toma de decisiones financieras"
  },
  {
    icon: Users,
    title: "Comunidad de Aprendizaje",
    description: "Un espacio seguro donde los niños aprenden, comparten y crecen juntos"
  },
  {
    icon: TrendingUp,
    title: "Resultados Medibles",
    description: "Seguimiento del progreso y desarrollo de habilidades en tiempo real"
  }
];

export const WhyChooseUs: FC = () => {
  return (
    <section className="py-12 md:py-24 bg-[#1A1F2C] text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold mb-4">
            ¿Por qué elegir FinancieraMente?
          </h2>
          <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto px-4">
            Porque invertir en la educación financiera de tus hijos hoy, 
            es asegurar su independencia y prosperidad mañana
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {whyChooseUs.map((item, index) => (
            <div key={index} className="bg-white/5 p-6 rounded-xl backdrop-blur-sm">
              <div className="h-12 w-12 rounded-lg bg-white/10 flex items-center justify-center mb-4">
                <item.icon className="h-6 w-6 text-[#22c55e]" />
              </div>
              <h3 className="text-lg md:text-xl font-bold mb-2">{item.title}</h3>
              <p className="text-sm md:text-base text-gray-300">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};